import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const NavKeys = {
  Income: "income",
  Costs: "costs",
  Analysis: "analysis",
  Documents: "documents",
  Employees: "employees",
  Administration: "administration",
  TimeReporting: "timeReporting",
  BusinessUnits: "businessUnits",
};

export const ReportKeys = {
  Receipt: "receipt",
  IncomingInvoice: "incomingInvoice",
  Invoice: "invoice",
  Support: "support",
  DocumentDraft: "documentDraft",
  SalaryDraft: "salaryDraft",
  Todo: "todo",
  QualifiedShareDividend: "qualifiedShareDividend",
  GenericDocuments: "genericDocuments",
  SIE: "sIE",
  GrossSalary: "grossSalary",
  SharedDocuments: "sharedDocuments",
  HoldingRegisters: "holdingRegisters",
  Customers: "customers",
};

export const TodoTypeToReportKey = {
  [WintSuperkollAPIModel.TodoType.Receipt]: ReportKeys.Receipt,
  [WintSuperkollAPIModel.TodoType.IncomingInvoice]: ReportKeys.IncomingInvoice,
  [WintSuperkollAPIModel.TodoType.Invoice]: ReportKeys.Invoice,
  [WintSuperkollAPIModel.TodoType.Support]: ReportKeys.Support,
  [WintSuperkollAPIModel.TodoType.DocumentDraft]: ReportKeys.DocumentDraft,
  [WintSuperkollAPIModel.TodoType.SalaryDraft]: ReportKeys.SalaryDraft,
  [WintSuperkollAPIModel.TodoType.QualifiedShareDividend]: ReportKeys.QualifiedShareDividend,
};
